import React, { useCallback, useEffect, useState, useRef } from "react";
import { useError } from "../../context/errorContext";
import Select from 'react-select';
import CloseIcon from '@mui/icons-material/Close';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import axiosInstance from "../../api/axiosInstance";
import "../viewEvent/viewEvent.scss"

const ViewDriver = ({ setSelectedDriverModal, selectedDriverModal, fetchData }) => {
    const [isLoading, setLoading] = useState(true);
    const [drivers, setDrivers] = useState([]);
    const [item, setItem] = useState({});

    const { showMessage } = useError();

    // Ref für das Modal
    const containerRef = useRef(null);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const [driversRes, itemRes] = await Promise.all([
                    axiosInstance.get(`forms/driver`),
                    axiosInstance.get(`items/${selectedDriverModal}`)
                ]);

                setDrivers(driversRes.data);
                setItem(itemRes.data);
                setLoading(false);
            } catch (err) {
                console.error(err);
            }
        };
        fetchData();
    }, [selectedDriverModal]);

    const handleInputChange = ({ value, label }) => {
        setItem((prev) => ({
            ...prev,
            driver: value,
            driverAlias: label
        }));
    };

    const handleChangeDriver = async () => {
        try {
            await axiosInstance.put(`items/driver/${selectedDriverModal}`, {
                driver: item.driver
            });

            showMessage("Fahrer geändert!")
            fetchData()
            setSelectedDriverModal(null)
        } catch (err) {
            console.error(err);
        }
    };

    const handleCloseModal = useCallback(() => {
        setSelectedDriverModal(null);
    }, [setSelectedDriverModal]);

    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === 'Escape') {
                handleCloseModal();
            }
        };

        window.addEventListener('keydown', handleKeyDown);

        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, [handleCloseModal]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (containerRef.current && !containerRef.current.contains(event.target)) {
                handleCloseModal();
            }
        };

        document.addEventListener("mousedown", handleClickOutside);

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [handleCloseModal]);

    if (!selectedDriverModal) return (<div />)

    if (isLoading) return (<div />)

    return (
        <div className="viewEvent" ref={containerRef}>
            <div className="topBar">
                <h5>Hauptfahrer</h5>
                <button className="closeBtn" onClick={handleCloseModal}>
                    <CloseIcon />
                </button>
            </div>
            <form onSubmit={(e) => { e.preventDefault() }}>
                <div className="group">
                    <ManageAccountsIcon />
                    <Select
                        options={drivers}
                        type="text"
                        name="driver"
                        className="reactSelect"
                        classNamePrefix="reactSelect"
                        value={{ label: item.driverAlias, value: item.driver }}
                        onChange={handleInputChange}
                        placeholder="Fahrer wählen"
                        isClearable={true}
                    />
                </div>
                <div className="bottom">
                    <button onClick={handleChangeDriver}>Speichern</button>
                </div>
            </form>
        </div>
    );
};

export default ViewDriver